import { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { ConfirmModal } from 'components/dialog/ModalTemplate'
import { hideBiddingAverages } from 'features/ad/keyword/keywordSlice'
import { Modal } from 'components/dialog/Modals'
import Table from 'components/table/Table'
import classNames from 'classnames'
import ErrorText from 'components/form/ErrorText'
import FixedTable from 'components/table/FixedTable'

const BiddingAveragesModal = () => {
  const dispatch = useDispatch()
  const {
    visible,
    rank,
    loading,
    keywords,
    content,
    useRankAmount,
    rankAmount,
  } = useSelector(state => state.ad.keyword.biddingAverages)
  const calculateRankAmount = useCallback(
    keyword => {
      const biddingAverageAmount = content
        ?.find(item => item.keyword === keyword)
        ?.[rank.device.toLowerCase()]?.find(
          item => item.rank === rank.rank
        )?.averageBiddingAmount
      const exceedRankAmount =
        useRankAmount && biddingAverageAmount > rankAmount
      const fixedBiddingAverageAmount = biddingAverageAmount
        ? exceedRankAmount
          ? Math.min(rankAmount, 100000)
          : biddingAverageAmount
        : 70
      return {
        fixedBiddingAverageAmount,
        exceedRankAmount,
      }
    },
    [content, useRankAmount, rankAmount, rank.device, rank.rank]
  )
  const hasFixedValue = keywords.some(
    keyword => calculateRankAmount(keyword).exceedRankAmount
  )
  return (
    <Modal on={visible} className="ranking_layer">
      <ConfirmModal
        showCancelBtn={false}
        confirmText="닫기"
        title={`${rank.device === 'MOBILE' ? '모바일' : rank.device} ${
          rank.rank
        }위 키워드 평균 입찰가`}
        handleClose={() => dispatch(hideBiddingAverages())}>
        <p className="desc_info">
          순위별 평균 입찰가는 프리미엄링크 캠페인 &gt; 검색매체 &gt;
          카카오지면을 통해 광고가 집행된 키워드의 최근 30일(어제로부터 과거
          30일까지) 과거 실적을 토대로 예측한 수치며 제공되는 데이터로 인한 광고
          성과를 보장하지 않습니다.
        </p>
        <FixedTable caption="키워드별 평균 입찰가 표" loading={loading}>
          <Table.Head>
            <Table.Column title="키워드" className="inner_cell" width={370} />
            <Table.Column title="평균 입찰가" className="inner_cell" />
          </Table.Head>
          <Table.Body>
            {keywords.map(keyword => {
              const { fixedBiddingAverageAmount, exceedRankAmount } =
                calculateRankAmount(keyword)
              return (
                <Table.Row rowId={keyword} key={keyword}>
                  <td>
                    <div className="inner_cell">
                      <span className="txt_limit2">{keyword}</span>
                    </div>
                  </td>
                  <td className="bg_emph">
                    <div
                      className={classNames('inner_cell', {
                        fc_warn: !loading && exceedRankAmount,
                      })}>
                      {fixedBiddingAverageAmount.toLocaleString()}원
                    </div>
                  </td>
                </Table.Row>
              )
            })}
          </Table.Body>
        </FixedTable>
        <ErrorText
          tag="p"
          error={hasFixedValue && '최대입찰가로 설정된 금액이 존재합니다.'}
        />
      </ConfirmModal>
    </Modal>
  )
}
export default BiddingAveragesModal
